import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-wrap":"wrap"} }
const _hoisted_2 = {
  key: 0,
  style: {"color":"#10b981"}
}
const _hoisted_3 = {
  key: 1,
  style: {"color":"yellow"}
}

import { ref, computed } from 'vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Card from 'primevue/card'
import Tag from 'primevue/tag'
import Toast from 'primevue/toast'
import { copyText } from 'vue3-clipboard'
import { formatPrice } from '@/common/function'
import type { MinimalPrice, TableItem } from '@/types/auction'


export default /*@__PURE__*/_defineComponent({
  __name: 'TableSolo',
  props: {
    item: {},
    enteredProfitLots: {}
  },
  setup(__props: any) {

const toast = ref()

const props = __props

function styleColor(data) {
  if (data.startPriceOne && data.duration48) {
    return 'color: #d68686'
  } else if (data.startPriceOne) {
    return 'color: #10b981'
  } else if (data.duration48) {
    return 'color: yellow'
  } else {
    return ''
  }
}

const filteredProfitList = computed(() => {
  return props.item.profitList
    .filter(item => item.priceDifferenceResult > props.enteredProfitLots)
    .map(item => ({
      ...item,
      buyoutPrice: Number(item.buyoutPrice) || 0,
      averagePrice: Number(item.averagePrice) || 0,
      priceDifferenceResult: Number(item.priceDifferenceResult) || 0
    }))
})

const getPriceSeverity = (itemSize: MinimalPrice) => {
  if (!itemSize.value) return 'info'
  return props.item.historyAveragePrice * itemSize.size > itemSize.value ? 'danger' : 'success'
}

const copyingNotification = (text: string) => {
  toast.value?.add({
    severity: 'info',
    summary: 'Скопировано',
    detail: text,
    life: 3000
  })
}

const copyToClipboard = (text: string) => {
  copyingNotification(text)
  copyText(text, undefined, (error: Error) => {
    if (error) console.error('Copy error:', error)
  })
}

const copyToClipboardPrice = (price: number | null) => {
  if (price === null) return
  copyingNotification(price.toString())
  copyText(price - 1, undefined, (error: Error) => {
    if (error) console.error('Copy error:', error)
  })
}

const tooltipContent = computed(() => {
  return `
  <div class="price-history-tooltip">
    <div class="tooltip-title">История цен</div>
    <table class="tooltip-table">
      <thead>
        <tr>
          <th>Период</th>
          <th>Средняя цена</th>
          <th>Продано</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1 час</td>
          <td>${props.item.stats.hourly.average} ₽</td>
          <td>${props.item.stats.hourly.totalAmount}</td>
        </tr>
        <tr>
          <td>1 день</td>
          <td>${props.item.stats.daily.average} ₽</td>
          <td>${props.item.stats.daily.totalAmount}</td>
        </tr>
        <tr>
          <td>3 дня</td>
          <td>${props.item.stats.threeDays.average} ₽</td>
          <td>${props.item.stats.threeDays.totalAmount}</td>
        </tr>
        <tr>
          <td>1 неделя</td>
          <td>${props.item.stats.weekly.average} ₽</td>
          <td>${props.item.stats.weekly.totalAmount}</td>
        </tr>
      </tbody>
    </table>
  </div>
`
})

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Toast), {
      ref_key: "toast",
      ref: toast
    }, null, 512),
    _withDirectives((_openBlock(), _createBlock(_unref(Card), { class: "lot-card" }, {
      content: _withCtx(() => [
        _createElementVNode("div", {
          class: "lot",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (copyToClipboard(_ctx.item.name)))
        }, [
          _createElementVNode("strong", {
            style: _normalizeStyle({
            color:
              _ctx.item.id === 'dm6l2_1'
                ? '#4CAF50'
                : _ctx.item.id === 'dm6l2_2'
                ? '#2196F3'
                : _ctx.item.id === 'dm6l2_3'
                ? '#9C27B0'
                : _ctx.item.id === 'dm6l2_4'
                ? '#F44336'
                : '#E0E0E0'
          })
          }, _toDisplayString(_ctx.item.name), 5),
          _createTextVNode(" (" + _toDisplayString(_unref(formatPrice)(_ctx.item.historyAveragePrice)) + ") ", 1)
        ]),
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.minimal, (itemSize) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${itemSize.size}-${itemSize.value}`
            }, [
              _createVNode(_unref(Tag), {
                severity: getPriceSeverity(itemSize),
                class: "lot-size",
                onClick: ($event: any) => (copyToClipboardPrice(itemSize.value))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(itemSize.size) + ": " + _toDisplayString(_unref(formatPrice)(itemSize.value)), 1)
                ]),
                _: 2
              }, 1032, ["severity", "onClick"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    })), [
      [
        _directive_tooltip,
        {
      // value: tooltipContent,
      escape: false,
      pt: {
        root: {
          class: 'custom-tooltip'
        }
      }
    },
        void 0,
        { bottom: true }
      ]
    ]),
    (filteredProfitList.value.length)
      ? (_openBlock(), _createBlock(_unref(Card), {
          key: 0,
          class: "auction-card"
        }, {
          content: _withCtx(() => [
            _createVNode(_unref(DataTable), {
              value: filteredProfitList.value,
              responsiveLayout: "scroll",
              sortField: 'priceDifferenceResult',
              sortOrder: -1
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Column), {
                  field: "buyoutPrice",
                  header: "Общая цена",
                  sortable: true,
                  sortField: 'buyoutPrice'
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      style: _normalizeStyle(styleColor(data))
                    }, _toDisplayString(_unref(formatPrice)(data.buyoutPrice)) + " (" + _toDisplayString(data.amount) + ") ", 5),
                    (data.startPriceOne)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "1Р"))
                      : _createCommentVNode("", true),
                    (data.duration48)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "48Ч"))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), {
                  field: "averagePrice",
                  header: "Средняя цена",
                  sortable: true,
                  sortField: 'averagePrice'
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(_unref(formatPrice)(data.averagePrice)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), {
                  field: "priceDifferenceResult",
                  header: "Прибыль",
                  sortable: true,
                  sortField: 'priceDifferenceResult'
                }, {
                  body: _withCtx(({ data }) => [
                    _createVNode(_unref(Tag), {
                      severity: data.priceDifferenceResult > 0 ? 'success' : 'danger'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(formatPrice)(data.priceDifferenceResult)) + " ₽ ", 1)
                      ]),
                      _: 2
                    }, 1032, ["severity"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})